// Generated by purs version 0.15.15
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var AutomaticIsSymbol = {
    reflectSymbol: function () {
        return "Automatic";
    }
};
var ManualIsSymbol = {
    reflectSymbol: function () {
        return "Manual";
    }
};
var genericTopConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments);
var genericBottomConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments);
var genericEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments);
var genericEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericEnumSum(genericEnumConstructor)(genericTopConstructor)(genericEnumConstructor)(genericBottomConstructor);
var genericBoundedEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments);
var genericBoundedEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(genericBoundedEnumConstructor)(genericBoundedEnumConstructor);
var Automatic = /* #__PURE__ */ (function () {
    function Automatic() {

    };
    Automatic.value = new Automatic();
    return Automatic;
})();
var Manual = /* #__PURE__ */ (function () {
    function Manual() {

    };
    Manual.value = new Manual();
    return Manual;
})();
var eqCrossSellingKind = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Automatic && y instanceof Automatic) {
                return true;
            };
            if (x instanceof Manual && y instanceof Manual) {
                return true;
            };
            return false;
        };
    }
};
var ordCrossSellingKind = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Automatic && y instanceof Automatic) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Automatic) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Automatic) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Manual && y instanceof Manual) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Analytics.Types.CrossSellingKind (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqCrossSellingKind;
    }
};
var genericCrossSellingKind = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Automatic.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return Manual.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.CrossSellingKind (line 17, column 1 - line 17, column 87): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Automatic) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Manual) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.CrossSellingKind (line 17, column 1 - line 17, column 87): " + [ x.constructor.name ]);
    }
};
var showCrossSellingKind = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCrossSellingKind)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(AutomaticIsSymbol))(/* #__PURE__ */ genericShowConstructor(ManualIsSymbol)))
};
var unscrambleDecodeCrossSellingKind = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericCrossSellingKind)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(AutomaticIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(ManualIsSymbol)))(Unscramble_Enum.defaultEnumOptions)
};
var boundedCrossSellingKind = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericCrossSellingKind)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(genericTopConstructor)),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericCrossSellingKind)(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(genericBottomConstructor)),
    Ord0: function () {
        return ordCrossSellingKind;
    }
};
var enumCrossSellingKind = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericCrossSellingKind)(genericEnumSum),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericCrossSellingKind)(genericEnumSum),
    Ord0: function () {
        return ordCrossSellingKind;
    }
};
var boundedEnumCrossSellingKi = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericCrossSellingKind)(genericBoundedEnumSum),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericCrossSellingKind)(genericBoundedEnumSum),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericCrossSellingKind)(genericBoundedEnumSum),
    Bounded0: function () {
        return boundedCrossSellingKind;
    },
    Enum1: function () {
        return enumCrossSellingKind;
    }
};
var toFillFormTypeCrossSellin = {
    fillFormDataType: /* #__PURE__ */ Restaumatic_Form_TestHelpers.defaultEnumFillFormDataType(genericCrossSellingKind)(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(AutomaticIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(ManualIsSymbol)))
};
var encodeCrossSellingKind = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericCrossSellingKind)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(AutomaticIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(ManualIsSymbol)))
};
var decodeCrossSellingKind = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericCrossSellingKind)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(AutomaticIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(ManualIsSymbol)))
};
export {
    Automatic,
    Manual,
    genericCrossSellingKind,
    eqCrossSellingKind,
    showCrossSellingKind,
    encodeCrossSellingKind,
    decodeCrossSellingKind,
    unscrambleDecodeCrossSellingKind,
    ordCrossSellingKind,
    enumCrossSellingKind,
    boundedCrossSellingKind,
    boundedEnumCrossSellingKi,
    toFillFormTypeCrossSellin
};
